import { createContext } from 'react';

import DataObjects from './dataObjects';

// Variables globals de context que es compartiran i manipularan des de diferents pantalles
export const SessionContext = createContext(new DataObjects('sessionData'));

// Variables globals de context relatives al pacient
// export const PatientContext = createContext(new DataObjects('patientData'));

// Variables globals de context relatives al pacient amb informació que es maneja a nivell local i que no s'ha d'enviar al servidor
// export const PatientContextLocal = createContext(new DataObjects('patientLocalData'));
